<gen-options-button class='bulk-operation-data-wrapper'
        [buttonText]="bulkOperationConfig?.label | translate"
        [options]="bulkOperationOptions"
        [disabled]="disabled">
</gen-options-button>